import React, { useEffect, useCallback } from 'react';
import { CaretLeft, CaretRight, X } from '@phosphor-icons/react';
import classNames from 'classnames';

import { Person } from '../../types';
import { Button } from '../general';

interface Props {
  group: Person[];
  id: string | null;
  setId: (newId: string | null) => void;
}

const HeadingBtnGroup: React.FC<Props> = (props) => {
  const { group, id, setId } = props;

  const onClick = useCallback(
    (type: string) => {
      const index = group.findIndex((faceObj) => faceObj.face.elementId === id);

      if (type === 'next') {
        let nextIndex = index + 1;
        if (nextIndex >= group.length) nextIndex = 0;
        setId(group[nextIndex].face.elementId);
      } else if (type === 'prev') {
        let prevIndex = index - 1;
        if (prevIndex < 0) prevIndex = group.length - 1;
        setId(group[prevIndex].face.elementId);
      } else if (type === 'close') {
        setId(null);
      }
    },
    [group, id, setId],
  );

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') onClick('next');
      else if (e.key === 'ArrowLeft') onClick('prev');
      else if (e.key === 'Escape') onClick('close');
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClick]);

  return (
    <div className="flex">
      {group.length > 1 && (
        <React.Fragment>
          <Button
            id="heading-left-btn"
            variant="primary-thin"
            colour="light-grey"
            className="w-12 text-[1.2rem] rounded-r-none"
            onClick={() => onClick('prev')}
          >
            <CaretLeft />
          </Button>

          <Button
            id="heading-right-btn"
            variant="primary-thin"
            colour="light-grey"
            className="w-12 text-[1.2rem] rounded-none border-x border-grey-200 border-solid"
            onClick={() => onClick('next')}
          >
            <CaretRight />
          </Button>
        </React.Fragment>
      )}

      <Button
        id="heading-close-btn"
        variant="primary-thin"
        colour="light-grey"
        className={classNames('w-12 text-[1.2rem]', {
          'rounded-l-none': group.length > 1,
        })}
        onClick={() => onClick('close')}
      >
        <X />
      </Button>
    </div>
  );
};

export default HeadingBtnGroup;
